import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import PromoCode from '../../../smoothr-web-app-core/models/PromoCode';

export enum AutomaticPromoModalResult {
	CONFIRM,
	DECLINE,
}

@Component({
	selector: 'app-automatic-promo-modal',
	imports: [IonicModule, CommonModule, TranslateModule],
	templateUrl: './automatic-promo-modal.component.html',
	styleUrl: './automatic-promo-modal.component.css',
	standalone: true,
})
export class AutomaticPromoModal {
	private modalCtrl = inject(ModalController);
	private translate = inject(TranslateService);

	@Input() promoCode: PromoCode;

	get title(): string {
		return this.promoCode?.name ?? '';
	}

	get description(): string {
		const desc = this.promoCode?.description;
		if (!desc) {
			return '';
		}
		const lang = this.translate.currentLang || this.translate.getDefaultLang() || 'en';
		return desc[lang] ?? desc.en ?? desc.de ?? '';
	}

	private imageFallbackIndex = 0;

	get imageUrl(): string | null {
		const candidates = this.imageCandidates;
		return candidates[this.imageFallbackIndex] ?? null;
	}

	private get imageCandidates(): string[] {
		const image = this.promoCode?.image;
		if (!image) {
			return [];
		}
		return [image.large, image.medium, image.original, image.thumb].filter(Boolean);
	}

	onImageError() {
		if (this.imageFallbackIndex < this.imageCandidates.length - 1) {
			this.imageFallbackIndex++;
		}
	}

	static async show(modalCtrl: ModalController, promoCode: PromoCode): Promise<AutomaticPromoModalResult> {
		const modal = await modalCtrl.create({
			component: AutomaticPromoModal,
			cssClass: 'automatic-promo-modal',
			componentProps: { promoCode },
		});
		console.log(promoCode);
		await modal.present();
		const result = (await modal.onDidDismiss()).data as AutomaticPromoModalResult | undefined;
		return result ?? AutomaticPromoModalResult.DECLINE;
	}

	onConfirmClick() {
		this.modalCtrl.dismiss(AutomaticPromoModalResult.CONFIRM);
	}

	onDeclineClick() {
		this.modalCtrl.dismiss(AutomaticPromoModalResult.DECLINE);
	}
}
